module.exports = __webpack_public_path__ + "img/female.b5935415.svg";